import * as actions from '../actionTypes'
const initialState = [];

const subjectsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_SUBJECT:
            return state.filter((subject) => subject._id !== action.payload);
        case actions.SET_SUBJECTS:
            return action.payload;
        case actions.ADD_SUBJECT:
            return [...state, action.payload];
        case actions.UPDATE_SUBJECT: {
            return state.map((subject) => subject._id === action.payload._id ? action.payload :subject);
        }
        default:
            return state;
    }
};

export default subjectsReducer;

